'use client';
import React from 'react';
import { MoneyBlocks } from './MoneyBlocks';
import styled from '@benzinga/themetron';
import { getSessionSingleton } from '@benzinga/session';
import { ContentManager, WordpressPost } from '@benzinga/content-manager';
import { NoFirstRender } from '@benzinga/hooks';
const LayoutAdmin = React.lazy(() => import('@benzinga/blocks').then(module => ({ default: module.LayoutAdmin })));

export interface MoneyPostProps {
  children?: React.ReactNode;
  post: WordpressPost | null;
  showTitle?: boolean;
  lazyLoadEnabled?: boolean;
  lazyLoadStartIndex?: number;
}

export const MoneyPost: React.FC<MoneyPostProps> = ({
  children,
  lazyLoadEnabled,
  lazyLoadStartIndex,
  post,
  showTitle = true,
}) => {
  return (
    <MoneyPostWrapper className="money-post-wrapper">
      <NoFirstRender>
        <React.Suspense>{post && <LayoutAdmin post={post} showClearCache={true} />}</React.Suspense>
      </NoFirstRender>
      {showTitle ? <h2>{post?.title}</h2> : null}
      {children}
      {post && (
        <MoneyBlocks
          blocks={post?.blocks}
          campaigns={post?.campaigns}
          lazyLoadEnabled={lazyLoadEnabled}
          lazyLoadStartIndex={lazyLoadStartIndex}
          post={post}
        />
      )}
    </MoneyPostWrapper>
  );
};

export const getMoneyPost = async (post_id: number) => {
  const session = getSessionSingleton();
  const contentManager = session.getManager(ContentManager);
  const pageRes = await contentManager.getPage(post_id);
  return pageRes?.ok ?? null;
};

export const MoneyPostWrapper = styled.div``;
